export default "__VITE_ASSET__eacf2842__"